const MyPageUsers = {
  el: {
    root: document.querySelector<HTMLElement>('.mypage-users'),
    addForm: document.querySelector<HTMLFormElement>('.mypage-users__add-form'),
    backButton: document.querySelector<HTMLAnchorElement>('.mypage-users__back-button'),
    dropdownTrigger: document.querySelector<HTMLAnchorElement>('.top__user-trigger'),
    userDropdown: document.querySelector<HTMLElement>('.top__user-dropdown'),
    companyTriggers: document.querySelectorAll<HTMLAnchorElement>('.top__user-dropdown-item'),
    changeUserForm: document.querySelector<HTMLFormElement>('.top__user-change-access-form'),
  },
  init() {
    if (this.el.dropdownTrigger) {
      this.handleUserDropDown()
      this.handleChangeUser()
    }

    this.handleBackButton()
  },
  handleBackButton() {
    if (this.el.backButton) {
      this.el.backButton.addEventListener('click', (e: Event & { target: HTMLAnchorElement }) => {
        e.preventDefault()
        window.history.go(-1)
      })
    }
  },
  handleUserDropDown() {
    this.el.dropdownTrigger.addEventListener('click', e => {
      e.preventDefault()
      this.el.userDropdown.classList.toggle('open')
    })
  },
  handleChangeUser() {
    Array.prototype.forEach.call(this.el.companyTriggers, item => {
      item.addEventListener('click', e => {
        e.preventDefault()

        const hiddenValue = this.el.changeUserForm.querySelector<HTMLInputElement>('[name="ssn"]')
        hiddenValue.value = e.target.dataset.ssn;

        this.changeUser()
      })
    })
  },
  async changeUser() {
    const formData = new FormData(this.el.changeUserForm)

    const req = await fetch(
      this.el.changeUserForm.getAttribute('action'),
      {
        method: this.el.changeUserForm.getAttribute('method'),
        body: formData,
      }
    )

    if (req.status >= 200 && req.status < 300) {
      window.location.reload()
    }
    else {
      alert('Error. Contact administrator.')
    }
  }
}

export default MyPageUsers
